/** WorktimeImportStatus enumeration */
export enum WorktimeImportStatus {
  Uploaded = "uploaded",
  Parsed = "parsed",
  Processing = "processing",
  Processed = "processed",
  Error = "error",
  Archived = "archived",
}